/**
 * The bounds on an administrator password: long, not clever.
 *
 * No character-class rule: those push people towards `Password1!` and a
 * passphrase is stronger than anything a class rule produces. The floor is
 * high because this door is only ever opened by four people who can use a
 * password manager, and because the account behind it can release held orders.
 * Shared so the screens that ask for one state the rule the worker enforces.
 */
export const PASSWORD_MIN = 12;
export const PASSWORD_MAX = 200;
//# sourceMappingURL=passwords.js.map